import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-175646f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ccn-cookie-category__headline-container" }

import { ref } from 'vue';
  import { ICookieListEntry } from '../../common/interfaces/index.interface';
  import { ETextSize, EToggleSize } from '../../common/enums/index.enum';
  import CustomHeadline from './CustomHeadline.vue';
  import ArrowIcon from './ArrowIcon.vue';
  import CustomToggle from './CustomToggle.vue';
  import ExplanationParagraph from './ExplanationParagraph.vue';
  import CookieList from './CookieList.vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CookieCategory',
  props: {
    active: { type: Boolean, default: false },
    cookies: {},
    disabled: { type: Boolean, default: false },
    explanation: { default: `` },
    headline: {},
    indeterminate: { type: Boolean, default: false },
    name: {}
  },
  setup(__props: any) {

  

  const showCookieList = ref(false);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["ccn-cookie-category", { 'ccn-cookie-category--disabled': _ctx.disabled }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(CustomHeadline, {
        class: "ccn-cookie-category__headline",
        size: _unref(ETextSize).SM,
        text: _ctx.$t(_ctx.headline)
      }, null, 8, ["size", "text"]),
      _createElementVNode("span", {
        class: "ccn-cookie-category__show-more",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (showCookieList.value = !showCookieList.value))
      }, [
        _createTextVNode(_toDisplayString(showCookieList.value ? _ctx.$t(`${_ctx.$translationsUfeNamespace}preferences.less`) : _ctx.$t(`${_ctx.$translationsUfeNamespace}preferences.moreDetails`)) + " ", 1),
        _createVNode(ArrowIcon, {
          class: _normalizeClass(["ccn-cookie-category__arrow", { 'ccn-cookie-category__arrow--inverted' : showCookieList.value }])
        }, null, 8, ["class"])
      ]),
      _createVNode(CustomToggle, {
        active: _ctx.active,
        class: "ccn-cookie-category__toggle-mobile",
        disabled: _ctx.disabled,
        indeterminate: _ctx.indeterminate,
        size: _unref(EToggleSize).SM,
        "onUpdate:active": _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit(`update:active`, $event)))
      }, null, 8, ["active", "disabled", "indeterminate", "size"])
    ]),
    (_ctx.explanation)
      ? (_openBlock(), _createBlock(ExplanationParagraph, {
          key: 0,
          active: _ctx.active,
          class: "ccn-cookie-category__explanation",
          disabled: _ctx.disabled,
          indeterminate: _ctx.indeterminate,
          size: _unref(ETextSize).SM,
          text: _ctx.$t(_ctx.explanation),
          toggle: "",
          "toggle-size": _unref(EToggleSize).SM,
          "onUpdate:active": _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit(`update:active`, $event)))
        }, null, 8, ["active", "disabled", "indeterminate", "size", "text", "toggle-size"]))
      : _createCommentVNode("", true),
    (showCookieList.value)
      ? (_openBlock(), _createBlock(CookieList, {
          key: 1,
          class: "ccn-cookie-category__cookie-list",
          disabled: _ctx.disabled,
          entries: _ctx.cookies,
          "onUpdate:activeSingleCookie": _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit(`update:active-single-cookie`, { ...$event, cookieCategory: _ctx.name })))
        }, null, 8, ["disabled", "entries"]))
      : _createCommentVNode("", true),
    _createElementVNode("span", {
      class: "ccn-cookie-category__show-more-mobile",
      onClick: _cache[4] || (_cache[4] = ($event: any) => (showCookieList.value = !showCookieList.value))
    }, [
      _createTextVNode(_toDisplayString(showCookieList.value ? _ctx.$t(`${_ctx.$translationsUfeNamespace}preferences.less`) : _ctx.$t(`${_ctx.$translationsUfeNamespace}preferences.moreDetails`)) + " ", 1),
      _createVNode(ArrowIcon, {
        class: _normalizeClass(["ccn-cookie-category__arrow", { 'ccn-cookie-category__arrow--inverted' : showCookieList.value }])
      }, null, 8, ["class"])
    ])
  ], 2))
}
}

})